<template>
  <div id="manually-or-batch-upload">
    <div class="top">
      <img :src="passportOrIDcard === 2 ? sampleUrl : frontSample" alt="">

      <ul>
        <li v-for="(item, index) in ocrExplain" :key="index">{{item}}</li>
      </ul>
    </div>
    <div class="bottom">
      <el-button class="el-button--primary manually-add" @click="manuallyAdd()">手动添加申请人</el-button>
      <div class="batch-upload-box">
        <input type="file" class="faraway batch-upload-input" accept="image/png, image/jpeg" multiple="multiple" ref="batchUploadFiles" @change="batchUpload">
        <el-button type="primary" @click="batchUploadSelect()">{{passportOrIDcard === 2 ? '批量上传护照' : '批量上传身份证'}}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import sampleUrl from '../../assets/imgs/upload/passport-sample.png';
import frontSample from '../../assets/imgs/upload/id-card-front-sample.png';

export default {
  name: 'manuallyOrBatchUpload',
  props: {
    passportOrIDcard: {
      type: Number,
      default: 1,
      required: true,
    },
  },
  data() {
    return {
      sampleUrl,
      frontSample,
      importing: false,
      uploadInput: null,
      ocrExplain: this.passportOrIDcard === 2 ? ['上传清晰的护照首页', '彩色扫描件或手机拍照（JPG/PNG)', '露出四个边角，拍照不要反光', '有效期离出发日期应至少还有6个月'] : ['上传清晰的身份证人像面', '彩色扫描件或手机拍照（JPG/PNG)', '露出四个边角，不要压边', '拍照不要反光'],
    };
  },
  watch: {
    passportOrIDcard(newVal) {
      this.ocrExplain = newVal === 2 ? ['上传清晰的护照首页', '彩色扫描件或手机拍照（JPG/PNG)', '露出四个边角，拍照不要反光', '有效期离出发日期应至少还有6个月'] : ['上传清晰的身份证人像面', '彩色扫描件或手机拍照（JPG/PNG)', '露出四个边角，不要压边', '拍照不要反光'];
    },
  },
  methods: {
    batchUploadSelect() {
      this.$el.querySelector('#manually-or-batch-upload .batch-upload-input').click();
    },

    manuallyAdd() {
      // MtaH5.clickStat('sendonline');
      this.$emit('manuallyAdd', 1);
    },
    batchUpload(e) {
      const files = e.target.files;

      // 先判断一次上传的文件数量
      if (files.length > 20) {
        this.$message.error('一次最多上传 20 张图片');
        return;
      }
      this.$emit('batchUpload', files, 2);

      // 清除文件，避免返回后选择同一张图片时不触发 change 事件
      this.$refs.batchUploadFiles.value = null;
    },
  },
};
</script>

<style lang="less" scoped>
#manually-or-batch-upload {
  .top {
    padding-top: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    img{
      width: 300px;
      height: 210px;
    }
    ul {
      li {
        font-size: 14px;
        line-height: 50px;
        color: #333333;
        padding-left: 22px;
        background: url('../../assets/imgs/group-visa/icon-check-mark.png') 0 center no-repeat;
      }
    }
  }
  .bottom {
    text-align: center;
    display: flex;
    justify-content: space-between;
    margin: 50px 90px 20px 90px;
    button {
      width: 180px;
      height: 40px;
      border-radius: 4px;
      font-size: 14px;
    }
    .manually-add {
      background-color: #ffffff;
      color: #5e9be1;
    }

    .batch-upload-box {
      button {
        background-color: #5e9be1;
        color: #ffffff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/add-order/manually-or-batch-upload.vue